"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableCellActions", {
    enumerable: true,
    get: function() {
        return TableCellActions;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableCellActions = require("./useTableCellActions");
const _renderTableCellActions = require("./renderTableCellActions");
const _useTableCellActionsStylesstyles = require("./useTableCellActionsStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableCellActions = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableCellActions.useTableCellActions_unstable)(props, ref);
    (0, _useTableCellActionsStylesstyles.useTableCellActionsStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableCellActionsStyles_unstable')(state);
    return (0, _renderTableCellActions.renderTableCellActions_unstable)(state);
});
TableCellActions.displayName = 'TableCellActions';
